export default __webpack_public_path__ + "static/media/planisphere_logo.c2cd2a74.svg";